export const getStateInterface = () => {
  return {
    currentLanguage: null,
    currentTheme: null,
    currentLayout: null,
  };
};
